import type * as React from "react"

const MILESTONE_STATUSES = {
  PENDING: 1,
  IN_PROGRESS: 2,
  COMPLETED: 3,
  BLOCKED: 4
} as const

type MilestoneStatusesKeys = keyof typeof MILESTONE_STATUSES
type MilestoneStatuses = (typeof MILESTONE_STATUSES)[MilestoneStatusesKeys]

const MILESTONE_STATUSES_MAP: Record<
  MilestoneStatuses,
  {
    id: MilestoneStatuses
    value: MilestoneStatuses
    label: string
    style: React.CSSProperties
  }
> = {
  [MILESTONE_STATUSES.PENDING]: {
    id: MILESTONE_STATUSES.PENDING,
    value: MILESTONE_STATUSES.PENDING,
    label: "Pending",
    style: {
      color: "#616d73",
      backgroundColor: "#ECEFF1",
      borderColor: "#ECEFF1"
    }
  },
  [MILESTONE_STATUSES.IN_PROGRESS]: {
    id: MILESTONE_STATUSES.IN_PROGRESS,
    value: MILESTONE_STATUSES.IN_PROGRESS,
    label: "In Progress",
    style: {
      color: "#FF9800",
      backgroundColor: "#FFF3E0",
      borderColor: "#FFF3E0"
    }
  },
  [MILESTONE_STATUSES.COMPLETED]: {
    id: MILESTONE_STATUSES.COMPLETED,
    value: MILESTONE_STATUSES.COMPLETED,
    label: "Completed",
    style: {
      color: "#4CAF50",
      backgroundColor: "#E8F5E9",
      borderColor: "#E8F5E9"
    }
  },
  [MILESTONE_STATUSES.BLOCKED]: {
    id: MILESTONE_STATUSES.BLOCKED,
    value: MILESTONE_STATUSES.BLOCKED,
    label: "Blocked",
    style: {
      color: "#F44336",
      backgroundColor: "#FFEBEE",
      borderColor: "#FFEBEE"
    }
  }
}

export { MILESTONE_STATUSES, MILESTONE_STATUSES_MAP, type MilestoneStatuses }
